import React from 'react';
import { Button } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';

function NotFound() {
	return (
		<div className="no-match">
			<div>
				<p>
					¡Lo Sentimos! Esta página no existe o no cuantas con los privilegios
					suficientes para acceder esta sección.
				</p>
				<Button
					inverted
					basic
					size="tiny"
					content="Ir al dashboard"
					as={NavLink}
					to="/"
				/>
			</div>
		</div>
	);
}

export default NotFound;
